import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

import storeLoader from 'app/stores/storeLoader';
import AlertModel from 'app/stores/alerting/AlertModel';

import { Spinner, Suspense } from 'core/components';
import Page from 'app/components/page/Page';
import { generateDashboardLink, getDashboardHashLink } from 'app/components/links/DashboardLink.js';
import NotFound from 'app/views/NotFound';

@storeLoader('$dashboards')
@inject('$alerting')
@observer
export default class AlertingDashboardResolver extends Component {
  state = {
    isLoading: true,
    model: undefined,
    to: undefined
  };

  componentDidMount() {
    const alertModel = new AlertModel();

    alertModel
      .set({ id: this.alertId })
      .fetch()
      .then(() => {
        this.setState({ model: alertModel });
      })
      .catch((err) => {
        const msg = `Could not load alert ${this.alertId}`;
        console.error(msg, err.message);
        this.setState({ isLoading: false });
      });
  }

  componentDidUpdate() {
    const { loading } = this.props;
    const { model } = this.state;

    // the dashboard id check needs both the alert and the loaded dashboards collection
    if (model && !loading && !this.dashboardPathRequest) {
      this.dashboardPathRequest = this.getDashboardPath(model).then((to) => this.setState({ isLoading: false, to }));
    }
  }

  get alertId() {
    const { match } = this.props;

    return match?.params?.alertId;
  }

  getDashboardPath(model) {
    const { $alerting } = this.props;
    const dashboardId = this.getDashboardId(model);

    // encode the alert filters as dashboard parameters
    if (model.get('dimensionToKeyPart') && model.get('policy')) {
      return getDashboardHashLink(dashboardId, $alerting.getDashboardQuery(model)).catch(() =>
        generateDashboardLink(dashboardId)
      );
    }

    return Promise.resolve(generateDashboardLink(dashboardId));
  }

  getDashboardId(model) {
    const { match, $dashboards } = this.props;
    let { dashboardId } = match.params;

    // no dashboard id passed on the url, check the policy for one
    if (!dashboardId) {
      dashboardId = model?.policy?.dashboardID;
    }

    // check if its valid
    if (dashboardId && $dashboards.collection.get(dashboardId) !== undefined) {
      return dashboardId;
    }

    // couldn't find the dashboard, try to default to the Traffic Overview board
    const trafficOverview = $dashboards.collection.find(
      (dashboard) => dashboard.isPreset && dashboard.get('dash_title') === 'Traffic Overview'
    );

    return trafficOverview?.id;
  }

  render() {
    const { isLoading, to } = this.state;

    if (!to && !isLoading) {
      return <NotFound hideSubnav={false} title="Alert Not Found" text={`Alert ${this.alertId} was not found.`} />;
    }

    return (
      <Page title="Alerting" overflow="hidden" hideSubnav>
        <Suspense loading={isLoading} fallback={<Spinner intent="primary" m="auto" />}>
          {to && <Redirect to={to} />}
        </Suspense>
      </Page>
    );
  }
}
